<template>
  <div>
    <a-divider orientation="left">{{ user.dep }} 必修</a-divider>
    <course-list-simplified
        :present-courses="presentCourses"
        :courses-source="allCoursesList" />
  </div>
</template>
<script>
import {findDupNameCourses} from "@/courseProcessor";
import CourseListSimplified from "@/components/Element/CourseListSimplified";

export default {
  name: 'fixed-course-selection',
  components: {CourseListSimplified},
  data() {
    return {
      activeName: '素養'
    };
  }
  ,
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  },
  computed: {
    presentCourses() {
      var courses = this.allCoursesList
      let filter = (c) => c.dep_cname.includes(this.user.dep)
      // console.log(courses);
      courses = courses.filter(filter)
      console.log("Courses:",courses)
      courses = findDupNameCourses(courses).uniqueCourses
      console.log(courses)
      // console.log(courses)
      let search = this.searchString
      if (search) {
        courses = courses.filter(function (c) {
          c.desc.includes(search)
        })
      }
      return courses
    },
  },
}
</script>
<style>
el-table{
  height: 100%;
}
</style>
